@if (showStatusDot()) {
  <span class="hx-badge__dot" [style.background-color]="color() || null"></span>
}
<span class="hx-badge-content">{{ displayLabel() }}</span>
